import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import * as serviceWorker from './serviceWorker';
import Client from './lib/Client';
import { parseAppTTP } from './reducers/App/actions';
import data from './data/content.json';

// reducers
import TripPlannerApp from './reducers';

// containers
import App from './containers/App';

// styles
import './particles/index.scss';
import './App.css';

const store = createStore(TripPlannerApp, applyMiddleware(thunkMiddleware));

Client.fetchContent((err, res) => {
  if (err) {
    store.dispatch(parseAppTTP(data));
  } else {
    // eslint-disable-next-line no-lonely-if
    if (res.body) {
      store.dispatch(parseAppTTP(res.body));
    }
  }
});

ReactDOM.render(<App store={store} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
